import * as invertBy from 'lodash/invertBy'
import { InsightsPageType, AllInsightsPageType, OpportunitiesPageType } from 'interfaces/pages'
import { InsightDependency, PlacementType, InsightPlacement } from 'interfaces/insights'
import { OpportunityPlacement } from 'interfaces/opportunities'
import { CATEGORIZED_PAGES, TIMEFRAMED_PAGES } from 'constants/pages'
import { OPPORTUNITIES_PAGE_PLACEMENT } from 'constants/opportunities'

// also it is used to figure out whether the anchor has insights
export const INSIGHT_PAGES_BY_PLACEMENT: Record<InsightPlacement, InsightsPageType> = {
  feedposts_general:          'feedposts',
  feedposts_opportunities:    'feedposts',
  feedpost_general:           'feedpost',
  feedauthor_general:         'feedauthor',
  feedtag_general:            'feedtag',
  dashboard_general:          'dashboard',
  dashboard_opportunities:    'dashboard',
  dashboard_spending:         'dashboard',
  dashboard_debts:            'dashboard',
  dashboard_assets:           'dashboard',
  dashboard_networth:         'dashboard',
  dashboard_networth_ranking: 'dashboard',
  dashboard_creditscore:      'dashboard',
  assets_general:             'assets',
  assets_trend:               'assets',
  assets_rank:                'assets',
  assets_breakdown:           'assets',
  debts_general:              'debts',
  debts_trend:                'debts',
  debts_rank:                 'debts',
  debts_breakdown:            'debts',
  spending_general:           'spending',
  spending_trend:             'spending',
  spending_rank:              'spending',
  spending_categories:        'spending',
  spending_breakdown:         'spending',
  income_general:             'income',
  income_trend:               'income',
  income_rank:                'income',
  income_categories:          'income',
  income_breakdown:           'income',
  networth_general:           'networth',
  networth_trend:             'networth',
  networth_rank:              'networth',
  networth_change:            'networth',
  creditscore_general:        'creditscore',
  creditscore_trend:          'creditscore',
  creditscore_rank:           'creditscore',
  creditscore_categories:     'creditscore',
  future_general:             'future',
  future_trend:               'future',
  future_breakdown:           'future',
  future_opportunities:       'future',
  coaching_carousel:          'coaching',
  creditcard_carousel:        'creditcard',
}

export const INSIGHT_PLACEMENTS_BY_PAGE = invertBy(INSIGHT_PAGES_BY_PLACEMENT) as Record<InsightsPageType, InsightPlacement[]>

export const SOCIAL_INSIGHT_PAGES_BY_PLACEMENT: Record<OpportunityPlacement, OpportunitiesPageType> = {
  opportunities_main:         'opportunities',
}

export const SOCIAL_INSIGHT_PLACEMENTS_BY_PAGE = invertBy(SOCIAL_INSIGHT_PAGES_BY_PLACEMENT) as Record<OpportunitiesPageType, OpportunityPlacement[]>

function getPlacementsByPages (pages: AllInsightsPageType[]): PlacementType[] {
  return pages.reduce<PlacementType[]>(
    (placements, page) => {
      const iPage = page as InsightsPageType
      const siPage = page as OpportunitiesPageType
      placements.push(
        ...(INSIGHT_PLACEMENTS_BY_PAGE[iPage] || []),
      )
      placements.push(
        ...(SOCIAL_INSIGHT_PLACEMENTS_BY_PAGE[siPage] || [])
      )

      return placements
    },
    []
  )
}

const PLACEMENTS = Object.keys(INSIGHT_PAGES_BY_PLACEMENT) as PlacementType[]
const ALL_PLACEMENTS_BUT_HIGHLIGHTS = PLACEMENTS.filter(
  (placement) => placement !== 'dashboard_opportunities'
) as PlacementType[]
const ALL_PLACEMENTS_BUT_OPPORTUNITIES = PLACEMENTS.filter(
  (placement) => placement !== OPPORTUNITIES_PAGE_PLACEMENT
) as PlacementType[]

const TIMEFRAMED_PLACEMENTS = getPlacementsByPages(TIMEFRAMED_PAGES)
const CATEGORIZED_PLACEMENTS = getPlacementsByPages(CATEGORIZED_PAGES)

export const INSIGHT_PLACEMENT_DEPENDENCIES: Record<InsightDependency, PlacementType[]> = {
  peergroupRelation: ALL_PLACEMENTS_BUT_HIGHLIGHTS,
  timeframe: TIMEFRAMED_PLACEMENTS,
  category: CATEGORIZED_PLACEMENTS,
  incomeTracker: INSIGHT_PLACEMENTS_BY_PAGE['income'],
  spendingTracker: INSIGHT_PLACEMENTS_BY_PAGE['spending'],
  transaction: PLACEMENTS,
  pageChange: ALL_PLACEMENTS_BUT_OPPORTUNITIES,
  leftOpportunitiesPage: [OPPORTUNITIES_PAGE_PLACEMENT],
  future: ['future_breakdown', 'future_general', 'future_opportunities', 'future_trend'],
  dashboard: ['dashboard_opportunities'],
  coaching: ['coaching_carousel'],
  creditcard: ['creditcard_carousel'],
}
